import Stars from 'components/Stars'
import React, { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'

import {
  ItemImage,
  ItemImageContainer,
  ItemName,
  ItemPrice,
  ProductItemContainer,
  SpecialTag,
  SpecialTagContainer,
  TopCircle,
  SalePercentage,
} from './ProductItem.style'
import { BrowserView, MobileAndTabletView } from '../../DeviceDetect'
import Flash from '../../Icons/Flash'
import Star2 from '../../Icons/Star2'
import Gift from '../../Icons/Gift'
import Megaphone from 'components/Icons/Megaphone'
import { StorageStatusContainer } from '../../Widgets/ProductInside/MainInfo/MainInfo.style'
import useCart from 'store/CartProvider'
import useProduct from 'store/SingleProductProvider'
import Stock from '../../Icons/Stock'
import Cart from '../../Icons/Cart'
import ShoppingBag from '../../Icons/ShoppingBag'
import { Link } from 'react-router-dom'
import { onProductAddToCartEvent } from 'services/conversionevents'
import { useHistory } from 'react-router'
import { percentageSaleCalculator, isInSale } from 'consts'
import BestPrice from 'components/Icons/BestPrice'
import Wishlist from 'components/Icons/Wishlist'
import { useWishlistContext } from 'store/WishlistContext'

const truncateText = (text, wordLimit) => {
  const words = text.split(' ')
  if (words.length > wordLimit) {
    return words.slice(0, wordLimit).join(' ') + '...'
  }
  return text
}

const ProductItem = props => {
  const item = props.item || {}
  const { onlyPictureandPrice } = props
  const { onlyPicture } = props
  const { addToCart, payMethod } = useCart()
  const { addToWishlist } = useWishlistContext()
  const { product, chosenVariants } = useProduct()
  const history = useHistory()

  const textRef = useRef(null)
  const [expandedWidth, setExpandedWidth] = useState('')

  const itemAddedToCart = status => {
    let shouldRedirect = status === 'buy'

    setTimeout(() => {
      addToCart(item.sku, chosenVariants, true, shouldRedirect).then(() => {
        onProductAddToCartEvent(product, {
          payMethod: payMethod,
        })
        if (shouldRedirect) {
          history.push('/purchase')
        }
      })
    }, 300)
  }

  const handleCartClick = e => {
    e.preventDefault()
    itemAddedToCart('cart')
    toast.success(truncateText(item.name, 5) + ' დაემატა კალათაში')
  }

  const handleWishlistClick = e => {
    e.preventDefault()
    addToWishlist(item.sku, {})
  }

  useEffect(() => {
    if (textRef.current) {
      const textContentWidth = textRef.current.scrollWidth
      const totalCalculatedWidth = textContentWidth + 35

      setExpandedWidth(`${totalCalculatedWidth}px`)
    }
  }, [])

  const icons = {
    fast: (
      <SpecialTag
        type="fast"
        expandedWidth={expandedWidth}
        onClick={e => e.preventDefault()}
      >
        <Flash color="white" width="0.75rem" height="1rem" />
        <span ref={textRef}>სწრაფი მიტანა</span>
      </SpecialTag>
    ),
    top: (
      <SpecialTag
        type="top"
        expandedWidth={expandedWidth}
        onClick={e => e.preventDefault()}
      >
        <Star2 color="white" size="1rem" />
        <span ref={textRef}>პოპულარული</span>
      </SpecialTag>
    ),
    gift: (
      <SpecialTag
        type="gift"
        expandedWidth={expandedWidth}
        onClick={e => e.preventDefault()}
      >
        <Gift color="white" size="1rem" />
        <span ref={textRef}>საჩუქარი</span>
      </SpecialTag>
    ),
    last: (
      <SpecialTag
        type="last"
        expandedWidth={expandedWidth}
        onClick={e => e.preventDefault()}
      >
        <Megaphone color="white" size="1rem" />
        <span ref={textRef}>ბოლო ერთეული</span>
      </SpecialTag>
    ),
    best: (
      <SpecialTag
        type="best"
        expandedWidth={expandedWidth}
        onClick={e => e.preventDefault()}
      >
        <BestPrice />
        <span ref={textRef}>საუკეთესო ფასი</span>
      </SpecialTag>
    ),
  }

  return (
    <ProductItemContainer
      as={Link}
      to={item.slug ? `/product/${item.slug}` : item.url ? item.url : '/'}
      className="product-item"
      istop={item.top}
      nohover={props.nohover}
      itemScope
      data-nostock={item.stock_status === 0 || item.price === 0}
      itemProp="itemListElement"
      itemType="https://schema.org/Product"
    >
      <link
        itemProp="url"
        href={item.slug ? `/product/${item.slug}` : item.url ? item.url : '/'}
      />
      {item.top && <TopCircle>TOP</TopCircle>}

      <ItemImageContainer
        onlyPicture={onlyPicture}
        noStock={item.stock_status === 0 || item.price === 0}
      >
        <BrowserView>
          <ItemImage
            className={item.image2 ? 'hovered relative' : 'relative'}
            noStock={item.stock_status === 0}
          >
            <img
              itemProp="image"
              className="object-contain"
              src={item.image}
              loading="lazy"
              alt={item.name}
              role="presentation"
              decoding="async"
            />
            {item.image2 ? (
              <img
                className="second-image lazyload"
                data-src={item.image2}
                alt={item.name}
              />
            ) : null}
            {isInSale(item.old_price, item.price) && item.stock_status !== 0 ? (
              <SalePercentage productItem={true}>
                -{percentageSaleCalculator(item.old_price, item.price)}%
              </SalePercentage>
            ) : null}
          </ItemImage>
        </BrowserView>
        <MobileAndTabletView>
          <ItemImage className="relative">
            <img
              itemProp="image"
              className="object-contain"
              src={item.image}
              loading="lazy"
              alt={item.name}
            />
            {isInSale(item.old_price, item.price) && item.stock_status !== 0 ? (
              <SalePercentage productItem={true}>
                -{percentageSaleCalculator(item.old_price, item.price)}%
              </SalePercentage>
            ) : null}
          </ItemImage>
        </MobileAndTabletView>
      </ItemImageContainer>
      {!onlyPicture ? (
        <>
          {!onlyPictureandPrice ? (
            <SpecialTagContainer>
              {typeof icons[item.icon] !== 'undefined'
                ? icons[item.icon]
                : null}
            </SpecialTagContainer>
          ) : null}

          <StorageStatusContainer>
            {(item.stock_status === 1 || item.stock_status === 3) && (
              <div className="flex items-center justify-center">
                <span className="in-stock text-xs">
                  <Stock />
                  მარაგშია
                </span>
              </div>
            )}
            {item.stock_status === 2 && (
              <div className="flex items-center justify-center">
                <span className="check-amount-product-item text-xs text-center">
                  მარაგი გადასამოწმებელია
                </span>
              </div>
            )}
            {item.stock_status === 0 && (
              <div className="flex items-center justify-center">
                <div
                  className="font-bold"
                  style={{ fontSize: '0.9rem', paddingBottom: '0.7rem' }}
                >
                  არ არის მარაგში
                </div>
              </div>
            )}
          </StorageStatusContainer>

          <ItemPrice
            itemProp="offers"
            itemScope
            itemType="https://schema.org/Offer"
          >
            {item.price && !item.old_price ? (
              <p
                style={{ color: 'black' }}
                itemProp="price"
                content={item.price}
              >
                {item.price}
                <span
                  style={{ color: 'black' }}
                  className="price-icon"
                  itemProp="priceCurrency"
                  content="GEL"
                >
                  ₾
                </span>
              </p>
            ) : item.price ? (
              <p itemProp="price" content={item.price}>
                {item.price}
                <span
                  className="price-icon"
                  itemProp="priceCurrency"
                  content="GEL"
                >
                  ₾
                </span>
              </p>
            ) : null}
            {item.old_price && item.price ? (
              <span>{item.old_price}₾</span>
            ) : null}
          </ItemPrice>
          {!onlyPictureandPrice ? (
            <div className="stars-and-name">
              <Stars className="stars" amount={Math.round(item.rating / 2)} />
              <ItemName itemProp="name" color="black2">
                {truncateText(item.name, 5)}
              </ItemName>
              <div className="flex justify-between w-full items-center">
                <div className="flex gap-2">
                  <div
                    onClick={handleCartClick}
                    className="mobile-cart-container"
                  >
                    <Cart />
                  </div>
                  <div
                    className="mobile-cart-container"
                    onClick={handleWishlistClick}
                  >
                    <Wishlist height={20} width={20} />
                  </div>
                </div>
                <div className="mobile-buy-container">
                  <ShoppingBag />
                  <span> ყიდვა </span>
                </div>
              </div>
            </div>
          ) : null}
        </>
      ) : null}
    </ProductItemContainer>
  )
}

export default ProductItem
